import { OverlayProps } from '@allesauto/core/overlay';
import { SupportedCurrencies, SupportedLocales } from '@allesauto/utils/consts';

import { IReduxActionProps } from './../../Utils/index';
import {
  CLOSE_OVERLAY,
  HIDE_CART_NOTIFICATION,
  LOCALE_CHANGED,
  OPEN_OVERLAY,
  SET_CURRENCY,
  SET_OVERLAY_LOADING_STATE,
  SHOW_CART_NOTIFICATION,
  UPDATE_OVERLAY_PROPS,
} from '../../actions/app';

export interface AppState {
  locale: SupportedLocales;
  currency: SupportedCurrencies;
  googleMaps: {
    countryBoundary: string;
  };
  showOverlay: boolean;
  overlayProps: Omit<
    OverlayProps,
    'open' | 'onClose' | 'whiteLabelIntegrationSlug'
  >;
  showCartNotification: boolean;
  showDeleteAccountNotification: boolean;
}

const InitialAppState: AppState = {
  locale: SupportedLocales.DEFAULT,
  currency: SupportedCurrencies.DEFAULT,
  googleMaps: {
    countryBoundary: 'country:DE',
  },
  showOverlay: false,
  overlayProps: {
    withPaddings: true,
    showCloseButton: true,
    preventClose: false,
    children: null,
    isLoading: false,
  },
  showCartNotification: false,
  showDeleteAccountNotification: false,
};

const App = (state: AppState = InitialAppState, action: IReduxActionProps) => {
  switch (action.type) {
    case LOCALE_CHANGED:
      return {
        ...state,
        locale: action.payload?.locale,
      };
    case SET_CURRENCY:
      return {
        ...state,
        currency: action.payload?.currency,
      };
    case OPEN_OVERLAY:
      return {
        ...state,
        showOverlay: true,
        overlayProps: {
          ...InitialAppState.overlayProps,
          ...action.payload,
        },
      };
    case CLOSE_OVERLAY: {
      return {
        ...state,
        showOverlay: false,
      };
    }
    case SET_OVERLAY_LOADING_STATE: {
      return {
        ...state,
        overlayProps: {
          ...state.overlayProps,
          isLoading: action.payload?.loadingState,
        },
      };
    }
    case UPDATE_OVERLAY_PROPS: {
      return {
        ...state,
        overlayProps: {
          ...state.overlayProps,
          ...action.payload,
        },
      };
    }
    case SHOW_CART_NOTIFICATION:
      return {
        ...state,
        showCartNotification: true,
      };
    case HIDE_CART_NOTIFICATION:
      return {
        ...state,
        showCartNotification: false,
      };
    default:
      return state;
  }
};

export default App;
